jQuery(document).ready(function ($) {

    let currentScreenSize = document.documentElement.clientWidth;
    $(window).on("resize", function () {
        currentScreenSize = document.documentElement.clientWidth;

        resetNav();
    })

    $('.main-nav li ul.sub-menu').each(function (i) {
        const $submenu = $(this);
        const $link = $submenu.siblings('a');

        const submenuId = `submenu-${i + 1}`;
        $submenu.attr('id', submenuId).attr('hidden', true);

        $link.addClass('hasChildren').after(
            `<button class="arrow" type="button"
                    aria-label="Open sub-menu"
                    aria-expanded="false"
                    aria-controls="${submenuId}">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none" aria-hidden="true" focusable="false">
                    <path d="M6 4.99992L1.757 9.24292L0.343 7.82792L3.172 4.99992L0.343 2.17192L1.757 0.75692L6 4.99992Z" fill="#0861CE"/>
                </svg>
            </button>`
        );
    });

    $(document).on('click', '.arrow', function (e) {
        const $arrow = $(this);
        const submenuId = $arrow.attr('aria-controls');
        const $submenu = $('#' + submenuId);

        const isOpen = $arrow.attr('aria-expanded') === 'true';

        $arrow.attr('aria-expanded', String(!isOpen));
        $submenu.prop('hidden', isOpen);

        $arrow.toggleClass('arrowOpen', !isOpen);
        $submenu.toggleClass('submenuOpen', !isOpen);

        e.preventDefault();
    });

    function resetNav() {
        if (currentScreenSize < 1025) {
            $('.main-nav .sub-menu').slideUp('fast');
        }
    }
    resetNav();

    $('.menuToggle').on('click', function (e) {
        e.preventDefault();
        const $hamburgerMenu = $(this);
        const $menu = $('#main-nav-links');
        const isOpen = $hamburgerMenu.attr('aria-expanded') === 'true';

        $hamburgerMenu.attr('aria-expanded', String(!isOpen));
        $hamburgerMenu.toggleClass('close', !isOpen);
        $menu.slideToggle('fast');
        $('body').toggleClass('menuOpen', !isOpen);

        $('.arrow').each(function () {
            const itemWidth = $(this).siblings('.hasChildren').innerWidth();
            $(this).css('left', `calc(90% - ${itemWidth}px)`);
        });
    });

    // Mobile menu toggle
    // $('.menuToggle').on('click', function (e) {
    //     e.preventDefault();
    //     $('body').toggleClass('menuOpen');
    //     $('.main-nav__links').slideToggle('fast');
    //     $(this).toggleClass('close');
    //     $('.arrow').each(function (el) {
    //         let itemWidth = $(this).siblings('.hasChildren').innerWidth();
    //         $(this).css('left', `calc(90% - ${itemWidth}px)`);
    //     })
    // });

    // Reveal/hide navigation on scroll up/down
    // let body = $('body');
    // let lastScroll = 0;
    // window.addEventListener("scroll", () => {
    //     const currentScroll = window.pageYOffset;
    //     if (currentScroll <= 0) {
    //         body.removeClass('scrollUp');
    //     }

    //     if (!body.hasClass('menuOpen')) {
    //         if ((currentScroll > lastScroll) && !body.hasClass('scrollDown') && currentScroll > 130) {
    //             // down
    //             body.removeClass('scrollUp');
    //             body.addClass('scrollDown');
    //         } else if ((currentScroll < lastScroll) && body.hasClass('scrollDown')) {
    //             // up
    //             body.removeClass('scrollDown');
    //             body.addClass('scrollUp');
    //         }

    //         lastScroll = currentScroll;
    //     }
    // });


    // Makes entire nav button clickable
    $('.menu-item.button').on("click", function () {
        let $link_url = $(this).find('a').attr('href');
        window.location.href = $link_url;
    })

});